module.exports = __webpack_public_path__ + "static/media/onboarding-practice.d876cf12.svg";